import formatMoney, { type FormatOptions } from 'currency/formatMoney/index.js'

export default function formatCents(locale: string, cents: number, options: FormatOptions = {}): string {
  const precision = options.precision ?? (cents % 100 ? 2 : 0)
  return formatMoney(locale, cents / 100, { ...options, precision })
}
